import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { NativeSelect } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { inr, todayIST } from "@/lib/format";

export function PaymentDialog({ customer, onClose, onSaved }) {
  const [amount, setAmount] = useState("");
  const [mode, setMode] = useState("upi");
  const [note, setNote] = useState("");
  const [date, setDate] = useState(todayIST());
  const save = async () => {
    try {
      await api.post("/payments", { customer_id: customer.id, amount: +amount, mode, note, date });
      toast.success(`Payment of ${inr(amount)} recorded`);
      setAmount(""); setNote("");
      onSaved(); onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!customer} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="payment-dialog">
        <DialogHeader><DialogTitle className="font-display">Record payment · {customer?.name}</DialogTitle></DialogHeader>
        {customer?.balance > 0 && (
          <button className="text-left text-sm text-amber-700" onClick={() => setAmount(customer.balance)} data-testid="payment-fill-balance">
            Outstanding {inr(customer.balance)}. Tap to fill.
          </button>
        )}
        <div className="space-y-3">
          <div className="space-y-1"><Label>Amount (₹)</Label><Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="payment-amount-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1"><Label>Mode</Label>
              <NativeSelect value={mode} onChange={(e) => setMode(e.target.value)} data-testid="payment-mode-select">
                <option value="upi">UPI</option><option value="cash">Cash</option><option value="bank">Bank transfer</option>
              </NativeSelect>
            </div>
            <div className="space-y-1"><Label>Date</Label><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="payment-date-input" /></div>
          </div>
          <div className="space-y-1"><Label>Note</Label><Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. GPay ref" data-testid="payment-note-input" /></div>
        </div>
        <DialogFooter><Button className="bg-[#0F382C] hover:bg-[#134E3A]" disabled={!(+amount > 0)} onClick={save} data-testid="payment-save-btn">Save payment</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
